import type { ApiResponse, InvitationStatsResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

interface InvitationStatsFilters {
  programId?: string;
}

const fetchAffiliateInvitationStats = async (
  filters: InvitationStatsFilters
): Promise<InvitationStatsResponse> => {
  const params = new URLSearchParams();

  if (filters.programId) {
    params.append('programId', filters.programId);
  }

  const queryString = params.toString();
  const { data } = await api.get<ApiResponse<InvitationStatsResponse>>(
    `/dashboard/affiliates/invitations/stats${queryString ? `?${queryString}` : ''}`
  );

  if (!data.success || !data.data) {
    throw new Error(data.message || 'Failed to fetch invitation statistics');
  }

  return data.data;
};

interface InvitationStatsQueryOptions {
  enabled?: boolean;
}

export const useAffiliateInvitationStatsQuery = (
  brandId: string | null | undefined,
  filters: InvitationStatsFilters = {},
  options: InvitationStatsQueryOptions = {}
) => {
  return useQuery<InvitationStatsResponse, Error>({
    queryKey: ['program-invitations', 'stats', brandId ?? '', filters],
    queryFn: () => fetchAffiliateInvitationStats(filters),
    enabled: !!brandId && filters.programId !== '' && (options.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
